import React, { useEffect, useRef, useState } from "react";
import SidebarNav from "../Sidebar/SidebarNav.js";
import activitiesService from "../../../services/activitiesService.js";
import utilsHelper from "../../../helpers/utilsHelper.js";
import GanttLib from "frappe-gantt";
import '../../../../node_modules/frappe-gantt/dist/frappe-gantt.css';

const Gantt = () => {
    const ganttRef = useRef(null);
    const [tasks, setTasks] = useState([]);

    const lightColors = [
        "#FFB3BA", "#FFDFBA", "#FFFFBA", "#BAFFB3", "#BAE1FF",
        "#D3B6F1", "#F1BAFF", "#F4E1BA", "#B6F1FF", "#B3FFDA",
        "#FFB6F1", "#FFDAB3", "#D3F1BA", "#D1BAFF", "#F1D3BA",
        "#FFDAF7", "#B3F1D1", "#B4F1FF", "#FFBAE5", "#F5F1BA"
    ];

    const getTaskColor = () => {
        const randomIndex = Math.floor(Math.random() * lightColors.length);
        return lightColors[randomIndex];
    };

    useEffect(() => {
        activitiesService.getActivities(undefined, "created_at", "asc", undefined, 1, 300).then(dataResult => {
            try {
                const formattedTasks = dataResult.tasks.map((itemChart) => {
                    return {
                        id: itemChart.id.toString(),
                        name: itemChart.name,
                        start: utilsHelper.convertIsoToJsDate(itemChart.estimated_start).toISOString().slice(0, 10),
                        end: utilsHelper.convertIsoToJsDate(itemChart.estimated_end).toISOString().slice(0, 10),
                        progress: 0,
                        dependencies: "",
                        color: getTaskColor(itemChart),
                    };
                });
                setTasks(formattedTasks);
            } catch {}
        });
    }, []);

    useEffect(() => {
        if (tasks.length > 0 && ganttRef.current) {
            const gantt = new GanttLib(ganttRef.current, tasks, {
                view_mode: "Month",
                view_mode_select: true,
                language: "es",
                custom_popup_html: null,
                height: '100%',
                task_color: (task) => task.color,
            });

            const handleResize = () => {
                gantt.refresh();
            };

            window.addEventListener('resize', handleResize);

            return () => {
                window.removeEventListener('resize', handleResize);
            };
        }
    }, [tasks]);

    return (
        <div className="container-fluid" style={{background: 'url(/waves-white.png)'}}>
            <div className="row vh-100">

                <SidebarNav />

                <div className="p-4 content-container col-md-9 col-lg-10">
                    <h3 className="mb-4">
                        <i className="bi bi-bar-chart-steps"></i> Gantt
                    </h3>

                    <div ref={ganttRef}></div>
                </div>
            </div>
        </div>
    );
};

export default Gantt;
